import { postData } from "../helpers/postData";
import { closeModal, setModalContent } from "../modal";
import { getConstants } from "./constants";
import { createData, sendAgain } from "./send-open-modal";
import { messageTimer } from "./timer";

const { freeLessonModal } = getConstants();

if (freeLessonModal) {
  const currentUrl = window.location.href;
  freeLessonModal.addEventListener("click", (e) => {
    const btnSignUp = e.target.closest('[data-modal="sign-up"]');
    const btnSignUpCancel = e.target.closest('[data-modal="sign-up-cancel"]');

    const freeLessonStorage = JSON.parse(localStorage.getItem("freeLesson"));

    const click = freeLessonStorage.click + 1;

    if (btnSignUp) {
      closeMessage(freeLessonModal, click, freeLessonStorage);
      let { action, data } = createData(freeLessonModal);

      postData(action, data).then((res) => {
        if (res.status) {
          const title = res.title;
          const url = res.redirect_url;
          const desc = res.text;
          let time = res.time;

          localStorage.setItem(
            "freeLesson",
            JSON.stringify({
              click: data.number_click,
              text: desc,
              title: title,
              url: url,
              time: time,
              timer: time,
            })
          );
          localStorage.setItem(
            "freeLessonStatus",
            JSON.stringify({
              status: res.status,
            })
          );
          window.location.href = url;
          messageTimer(time, freeLessonModal);
          setModalContent(title, desc, url);
        } else {
          localStorage.setItem(
            "freeLessonStatus",
            JSON.stringify({
              status: res.status,
            })
          );
        }
      });
    }

    if (btnSignUpCancel) {
      closeMessage(freeLessonModal, click, freeLessonStorage);
      let { action, data } = createData(freeLessonModal);
      sendAgain(action, data, freeLessonModal);
    }
  });
}

function closeMessage(modal, click, storage) {
  closeModal(modal);
  localStorage.setItem(
    "freeLesson",
    JSON.stringify({
      ...storage,
      click: click,
      timer: storage.time,
    })
  );
  localStorage.removeItem("freeLessonTimer");
}
